import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { upperCase } from 'lodash';
import LinkModal from '@/components/LinkModal.vue';
import VueMarkdown from 'vue-markdown';
const weaponPropertiesModule = namespace('weaponProperties');
let LootWeaponsProperties = class LootWeaponsProperties extends Vue {
    created() {
        this.fetchWeaponProperties();
    }
    get propertyData() {
        return this.propertyList && this.propertyList.map((propertyString, index) => {
            const propertyName = upperCase(propertyString.split(' ')[0]);
            const text = (index > 0 ? ', ' : ' ') + propertyString;
            const propertyInfo = this.weaponProperties.find(({ name }) => upperCase(name) === propertyName);
            return { ...propertyInfo, text };
        }).filter(({ content }) => content);
    }
};
__decorate([
    Prop(Array)
], LootWeaponsProperties.prototype, "propertyList", void 0);
__decorate([
    weaponPropertiesModule.State
], LootWeaponsProperties.prototype, "weaponProperties", void 0);
__decorate([
    weaponPropertiesModule.Action
], LootWeaponsProperties.prototype, "fetchWeaponProperties", void 0);
LootWeaponsProperties = __decorate([
    Component({
        components: {
            LinkModal,
            VueMarkdown
        }
    })
], LootWeaponsProperties);
export default LootWeaponsProperties;
